import { ChunkReload } from './ChunkReload'
import type { ReloadStorage } from './ChunkReload'

function sessionStore(): ReloadStorage {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage
  } catch {
    return null
  }
}

/** The page's one `ChunkReload` (D-066), shared by `main.tsx`, the lazy loaders and the UI. */
export const pageReload = new ChunkReload({
  storage: sessionStore(),
  now: () => Date.now(),
  reload: () => window.location.reload(),
})

/** Lazy loaders call this when their `import()` rejects: the failure goes to `pageReload`. */
export function chunkFailed(err: unknown): void {
  console.warn('[reload] a code chunk failed to load', err)
  pageReload.failed()
}

/**
 * Vite fires `vite:preloadError` when a built dynamic import (or its preloads) fails; the
 * import still rejects afterwards (no `preventDefault`), so its caller shows its own fallback.
 */
export function installChunkReload(): void {
  window.addEventListener('vite:preloadError', (e) => chunkFailed(e.payload))
}
